const default_from_address = "SimpleEnding™ <no-reply@simpleending.com>"

module.exports = default_from_address